(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-collection-grid"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
      document.documentElement.classList.add('safari-browser');
    }
    // -------------------------------
    // ⏱ Countdown Timers (optimized)
    // -------------------------------
    const timers = Array.from(document.querySelectorAll('.gs-steal-badge-timmer'));
    if (timers.length) {
      const parsedTimers = timers.map((el) => {
        const parseTime = (raw) => {
          if (!raw) return null;
          if (/^\d+$/.test(raw)) {
            const n = Number(raw);
            return n > 1e12 ? Math.floor(n / 1000) : n; // handle ms vs sec
          }
          const ms = Date.parse(raw);
          return isNaN(ms) ? null : Math.floor(ms / 1000);
        };
        const startTs = parseTime(el.dataset.time_start);
        const endTs = parseTime(el.dataset.time_end);
        return { el, startTs, endTs };
      });

      function formatHHMMSS(sec) {
        sec = Math.max(0, Math.floor(sec));
        const h = Math.floor(sec / 3600);
        const m = Math.floor((sec % 3600) / 60);
        const s = sec % 60;
        return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
      }

      // Single global update loop
      const updateAll = () => {
        const now = Math.floor(Date.now() / 1000);
        parsedTimers.forEach((t) => {
          const { el, startTs, endTs } = t;
          if (!endTs) return (el.textContent = '00:00:00');

          if (startTs && now < startTs) {
            el.textContent = 'Not started';
            return;
          }

          const remaining = endTs - now;
          if (remaining <= 0) {
            el.textContent = '00:00:00';
            return;
          }

          el.textContent = formatHHMMSS(remaining);
        });
      };

      updateAll();
      setInterval(updateAll, 1000);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    
    if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
      document.documentElement.classList.add('safari-browser');
    }
    // -------------------------------
    // ⏱ Countdown Timers (optimized)
    // -------------------------------
    const timers = Array.from(document.querySelectorAll('.gs-steal-badge-timmer'));
    if (timers.length) {
      const parsedTimers = timers.map((el) => {
        const parseTime = (raw) => {
          if (!raw) return null;
          if (/^\d+$/.test(raw)) {
            const n = Number(raw);
            return n > 1e12 ? Math.floor(n / 1000) : n; // handle ms vs sec
          }
          const ms = Date.parse(raw);
          return isNaN(ms) ? null : Math.floor(ms / 1000);
        };
        const startTs = parseTime(el.dataset.time_start);
        const endTs = parseTime(el.dataset.time_end);
        return { el, startTs, endTs };
      });

      function formatHHMMSS(sec) {
        sec = Math.max(0, Math.floor(sec));
        const h = Math.floor(sec / 3600);
        const m = Math.floor((sec % 3600) / 60);
        const s = sec % 60;
        return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
      }

      // Single global update loop
      const updateAll = () => {
        const now = Math.floor(Date.now() / 1000);
        parsedTimers.forEach((t) => {
          const { el, startTs, endTs } = t;
          if (!endTs) return (el.textContent = '00:00:00');

          if (startTs && now < startTs) {
            el.textContent = 'Not started';
            return;
          }

          const remaining = endTs - now;
          if (remaining <= 0) {
            el.textContent = '00:00:00';
            return;
          }

          el.textContent = formatHHMMSS(remaining);
        });
      };

      updateAll();
      setInterval(updateAll, 1000);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["occasion-products-grid"]) return;
  try {
    
  const mainCollectionWraper = document.querySelector('.main-collection-section-wrapper');
  const collectionHandle = mainCollectionWraper.getAttribute('data-collection-handle');
  const collectionProductsCount = mainCollectionWraper.getAttribute('data-colelction-products-count');
  const placeholderImageUrl = mainCollectionWraper.getAttribute('data-placeholderImageUrl');
  const defaultSortBy = mainCollectionWraper.getAttribute('data-sort-by');

  const languageIsoCode = mainCollectionWraper.getAttribute('data-localization-language-iso-code');
  const countryIsoCode = mainCollectionWraper.getAttribute('data-localization-country-iso-code');
  const localizationCurrencyCode = mainCollectionWraper.getAttribute('data-localization-currency-code');
  const isMember = mainCollectionWraper.getAttribute('data-is-member');
  const isStealBadge = mainCollectionWraper.getAttribute('data-is-steal-badge');
  const isStealBadgeTimeStart = mainCollectionWraper.getAttribute('data-is-steal-badge-time-start');
  const isStealBadgeTimeEnd = mainCollectionWraper.getAttribute('data-is-steal-badge-time-end');
  const timerRemainingSeconds = mainCollectionWraper.getAttribute('data-timer-remaining-seconds');
  const timerDays = mainCollectionWraper.getAttribute('data-timer-days');
  const timerHours = mainCollectionWraper.getAttribute('data-timer-hours');
  const timerMinutes = mainCollectionWraper.getAttribute('data-timer-minutes');
  const timerSeconds = mainCollectionWraper.getAttribute('data-timer-seconds');
  let timerType = mainCollectionWraper.getAttribute('data-timer-type');

  let timerPart01Value = '';
  let timerPart02Value = '';

  if (timerDays > 1) {
    timerType = 'days';
    timerPart01Value = timerDays;
    timerPart02Value = '<span>Days Left</span>';
  } else if (timerHours > 1) {
    timerType = 'hours';
    timerPart01Value = timerHours;
    timerPart02Value = '<span>Hours Left</span>';
  } else {
    timerType = 'minutes';
    timerPart01Value = timerMinutes;

    // Equivalent of Liquid capture + for loop
    let spans = '';
    for (let i = 60; i >= 1; i--) {
      const formatted = i < 10 ? `0${i}` : i;
      spans += `<span>${formatted}</span>`;
    }

    timerPart02Value = spans;
  }

  // ================= CONFIGURATION =================
  const CONFIG = {
    shopDomain: 'gbcodedletsdothis.myshopify.com',
    accessToken: '77a1e46f9d7439d6717146801b9efc83',
    apiVersion: '2024-10',
    productsPerPage: 8,
  };

  // Construct API endpoint
  const API_ENDPOINT = `https://${CONFIG.shopDomain}/api/${CONFIG.apiVersion}/graphql.json`;

  // ================= STATE =================
  const STATE = {
    collectionHandle: collectionHandle,
    productType: null,
    currentPage: 1,
    hasNextPage: false,
    hasPreviousPage: false,
    endCursor: null,
    cursors: [null], // First page has null cursor
    isLoading: false,
    // sortBy: defaultSortBy || 'COLLECTION_DEFAULT', // JDK
    sortBy: defaultSortBy || 'BEST_SELLING', // JDK
    reverse: false, // JDK
    // sortKey: 'COLLECTION_DEFAULT',
    sortKey: 'BEST_SELLING',
    // NEW: Filter state
    activeFilters: {
      color: null,
      productType: null,
    },
  };

  // ================= DOM ELEMENTS =================
  let productList = document.querySelector('.product-list');
  let paginationContainer = document.getElementById('pagination');

  // ================= SORTING HELPER FUNCTIONS =================
  function parseSortOption(sortOptionValue) {
    // let sortKey = 'COLLECTION_DEFAULT';
    let sortKey = 'BEST_SELLING';
    let reverse = false;

    // Map Shopify sort values to GraphQL sort keys
    switch (sortOptionValue) {
      case 'manual':
        console.log('manual : Collection Default');
        
        sortKey = 'COLLECTION_DEFAULT';
        reverse = false;
        break;
      case 'best-selling':
        console.log('best-selling : BEST_SELLING');
        sortKey = 'BEST_SELLING';
        reverse = false;
        break;
      case 'title-ascending':
        sortKey = 'TITLE';
        reverse = false; // A-Z: ascending
        break;
      case 'title-descending':
        sortKey = 'TITLE';
        reverse = true; // Z-A: descending
        break;
      case 'price-ascending':
        sortKey = 'PRICE';
        reverse = false; // Low to high: ascending
        break;
      case 'price-descending':
        sortKey = 'PRICE';
        reverse = true; // High to low: descending
        break;
      case 'created-ascending':
        sortKey = 'CREATED';
        reverse = false; // Old to new: ascending
        break;
      case 'created-descending':
        sortKey = 'CREATED';
        reverse = true; // New to old: descending
        break;
      default:
        // sortKey = 'COLLECTION_DEFAULT';
        sortKey = 'BEST_SELLING';
        reverse = false;
    }

    return { sortKey, reverse };
  }

  // ================= FILTER COUNT DISPLAY FUNCTION =================
  function updateFilterCountDisplay() {

    // Calculate active filter count
    let activeFilterCount = 0;
    if (STATE.activeFilters.color) activeFilterCount++;
    if (STATE.activeFilters.productType) activeFilterCount++;

    // Update filter button text
    const filterButtons = document.querySelectorAll('.filter-btn');
    filterButtons.forEach((button) => {
      // Get the current text without the plus icon
      const originalContent = button.innerHTML;

      // Check if we already have a count in parentheses
      const hasExistingCount = /Filters\s*\(\d+\)/.test(button.textContent);

      // const textSpan = button.querySelector('span:not(.plusIcon)');
      // if (textSpan) {
      //   if (activeFilterCount > 0) {
      //     textSpan.textContent = `Filters (${activeFilterCount})`;
      //   } else {
      //     textSpan.textContent = 'Filters';
      //   }
      // } else {
      //   // If no span found, update the button text directly
      //   const buttonText = button.textContent || button.innerText;
      //   if (buttonText.includes('Filters')) {
      //     if (activeFilterCount > 0) {
      //       button.innerHTML = button.innerHTML.replace('Filters', `Filters (${activeFilterCount})`);
      //     } else {
      //       button.innerHTML = button.innerHTML.replace(/Filters\s*\(\d+\)/, 'Filters');
      //     }
      //   }
      // }
      if (activeFilterCount > 0) {
        // If count already exists, replace just the count part
        if (hasExistingCount) {
          const newContent = originalContent.replace(/Filters\s*\(\d+\)/, `Filters (${activeFilterCount})`);
          button.innerHTML = newContent;
        } else {
          // Add count for the first time - careful not to duplicate plus icon
          const plusIconMatch = originalContent.match(/(<img[^>]*plusIcon[^>]*>)/);
          const plusIcon = plusIconMatch ? plusIconMatch[0] : '';

          // Create new content
          const textWithoutIcon = originalContent.replace(plusIcon, '').trim();
          const baseText = textWithoutIcon.replace('Filters', 'Filters').trim();

          button.innerHTML = `${baseText} (${activeFilterCount}) ${plusIcon}`;
        }
      } else {
        // Remove count if no filters active
        const newContent = originalContent.replace(/Filters\s*\(\d+\)/, 'Filters');
        button.innerHTML = newContent;
      }
    });

    // Also update the clear filters link in drawer
    const clearFilterLink = document.getElementById('clear-filters-link');
    if (clearFilterLink) {
      if (activeFilterCount > 0) {
        clearFilterLink.classList.remove('disabled');
        clearFilterLink.style.cssText = 'pointer-events: auto; opacity: 1; cursor: pointer;';
        const span = clearFilterLink.querySelector('span');
        if (span) {
          span.textContent = `Clear Filters (${activeFilterCount})`;
        }
      } else {
        clearFilterLink.classList.add('disabled');
        clearFilterLink.style.cssText = 'pointer-events: none; opacity: 0.5; cursor: not-allowed;';
        const span = clearFilterLink.querySelector('span');
        if (span) {
          span.textContent = 'Clear Filters';
        }
      }
    }
  }

  // ================= DRAWER FILTER SYNC FUNCTION =================
  function syncDrawerFilters() {

    // Get all filter inputs in drawer
    const drawer = document.getElementById('facets-drawer');
    if (!drawer) return;

    // DON'T uncheck all inputs automatically - this was causing the issue
    // Instead, update only the ones that match our state

    // First, let's see what filters are actually checked in drawer
    const currentlyChecked = drawer.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked');

    // // Uncheck all inputs first
    // const allInputs = drawer.querySelectorAll('input[type="checkbox"], input[type="radio"]');
    // allInputs.forEach(input => {
    //   input.checked = false;
    // });

    // Check active filters
    if (STATE.activeFilters.color) {
      const colorInputs = drawer.querySelectorAll(`input[value*="${STATE.activeFilters.color}"], 
                                                    input[value*="${STATE.activeFilters.color.toLowerCase()}"],
                                                    input[value*="${STATE.activeFilters.color.toUpperCase()}"]`);
      colorInputs.forEach((input) => {
        // Check if input value matches the color filter
        if (
          input.value &&
          (input.value.toLowerCase().includes(STATE.activeFilters.color.toLowerCase()) ||
            input.value === STATE.activeFilters.color)
        ) {
          input.checked = true;
        }
      });
    } else {
      // If no color filter, uncheck any color-related inputs
      const colorInputs = drawer.querySelectorAll('input[name*="color"]:checked, input[name*="Color"]:checked');
      colorInputs.forEach((input) => {
        input.checked = false;
      });
    }

    if (STATE.activeFilters.productType) {
      const typeInputs = drawer.querySelectorAll(`input[value="${STATE.activeFilters.productType}"]`);
      typeInputs.forEach((input) => {
        if (input.value === STATE.activeFilters.productType) {
          input.checked = true;
        }
      });
    } else {
      // If no product type filter, uncheck any product type inputs
      const typeInputs = drawer.querySelectorAll(
        'input[name*="product_type"]:checked, input[name*="gs_product_type"]:checked'
      );
      typeInputs.forEach((input) => {
        input.checked = false;
      });
    }

  }

  // Open drawer event listener
  function setupDrawerEvents() {
    const drawer = document.getElementById('facets-drawer');
    if (drawer) {
      // Listen for drawer open
      drawer.addEventListener('open', function () {
        setTimeout(syncDrawerFilters, 100); // Small delay to ensure DOM is ready
      });

      // Also listen for drawer close to prevent unwanted changes
      drawer.addEventListener('close', function () {
        // Don't do anything on close - keep filters as is
      });
    }

    // Prevent drawer from auto-updating filters on close
    document.addEventListener(
      'click',
      function (e) {
        // Check if clicked on drawer close button or overlay
        if (
          e.target.closest('.drawer__close-button') ||
          e.target.closest('.drawer__overlay') ||
          (e.target.classList && e.target.classList.contains('drawer__overlay'))
        ) {
          // Don't sync filters on close
          e.stopImmediatePropagation();
        }
      },
      true
    );
  }

  // ================= SCROLL TAB INTO VIEW FUNCTION =================
  function scrollTabIntoView(tabButton) {
    if (!tabButton) return;

    // Get the tabs container
    const tabsContainer = document.querySelector('.occasion-collection-carousel');
    const outerContainer = document.getElementById('interlinking-carousel');

    if (!tabsContainer || !outerContainer) return;

    // Calculate positions
    const containerRect = outerContainer.getBoundingClientRect();
    const buttonRect = tabButton.getBoundingClientRect();
    const containerWidth = containerRect.width;
    const buttonWidth = buttonRect.width;
    const buttonLeft = buttonRect.left - containerRect.left;
    const buttonRight = buttonRect.right - containerRect.left;

    // Check if button is not fully visible
    const isFullyVisible = buttonLeft >= 0 && buttonRight <= containerWidth;

    if (!isFullyVisible) {
      // Scroll to make button visible
      const scrollLeft = tabsContainer.scrollLeft;
      const buttonOffsetLeft = tabButton.offsetLeft;

      // Calculate target scroll position
      let targetScroll = buttonOffsetLeft - containerWidth / 2 + buttonWidth / 2;

      // Ensure within bounds
      const maxScroll = tabsContainer.scrollWidth - containerWidth;
      targetScroll = Math.max(0, Math.min(targetScroll, maxScroll));

      // Smooth scroll
      tabsContainer.scrollTo({
        left: targetScroll,
        behavior: 'smooth',
      });

    }
  }

  // ================= ENHANCED FIND TAB BUTTON FUNCTION =================
  function findTabButtonByProductType(productType) {
    const tabButtons = document.querySelectorAll('.occasion-collection-button');
    for (const button of tabButtons) {
      const tabId = button.getAttribute('data-tab');
      const tab = document.getElementById(tabId);
      if (tab) {
        const tabProductType = tab.getAttribute('data-type');
        if (tabProductType && tabProductType.toLowerCase() === productType.toLowerCase()) {
          return button;
        }
      }
    }
    return null;
  }

  // ================= DYNAMIC GRAPHQL QUERY BUILDER =================
  function getGraphQLQuery() {
    // Build filters array
    let filters = [];

    // Only add product type filter if a specific type is selected (not 'all')
    if (STATE.productType && STATE.productType !== 'all') {
      filters.push(`{
          productMetafield: {
            namespace: "custom"
            key: "gs_product_type"
            value: "${STATE.productType}"
          }
        }`);
    }

    // Always include product type from active tab
    // if (STATE.productType) {
    //  filters.push(`{
    //      productMetafield: {
    //        namespace: "custom"
    //        key: "gs_product_type"
    //        value: "${STATE.productType}"
    //      }
    //    }`);
    // }

    // Add color filter if active
    if (STATE.activeFilters.color) {
      filters.push(`{
          productMetafield: {
            namespace: "luxury"
            key: "color_detail"
            value: "${STATE.activeFilters.color}"
          }
        }`);
    }

    // Build filters string
    let filtersString = '';
    if (filters.length > 0) {
      filtersString = `filters: [${filters.join(', ')}]`;
    }

    // $productType: String!,
    return `
        query CollectionProducts(
          $country: CountryCode!
          $handle: String!, 
          $cursor: String,
          $sortKey: ProductCollectionSortKeys,
          $reverse: Boolean
        )
        @inContext(country: $country) { 
          collection(handle: $handle) {
            products(
              first: ${CONFIG.productsPerPage}, 
              after: $cursor, 
              sortKey: $sortKey, 
              reverse: $reverse
              ${filtersString}
            ) {
              edges {
                cursor
                node {
                  id
                  title
                  handle
                  onlineStoreUrl
                  featuredImage {
                    url
                    altText
                    width
                    height
                  }
                  images(first: 10) {
                    nodes {
                      url
                      altText
                      width
                      height
                    }
                  }  
                  priceRange {
                    maxVariantPrice {
                      amount
                      currencyCode
                    }
                    minVariantPrice {
                      amount
                      currencyCode
                    }
                  }
                  compareAtPriceRange {
                    maxVariantPrice {
                      amount
                      currencyCode
                    }
                    minVariantPrice {
                      amount
                      currencyCode
                    }
                  }
                  vendor
                  productType
                }
              }
              pageInfo {
                hasNextPage
                hasPreviousPage
                endCursor
              }
            }
          }
        }
      `;
  }

  // ================= GRAPHQL QUERY =================

  // filters:[{ productType: $productType }]
  const COLLECTION_PRODUCTS_QUERY = `
      query CollectionProducts(
        $country: CountryCode!
        $handle: String!, 
        $productType: String!, 
        $cursor: String,
        $sortKey: ProductCollectionSortKeys,
        $reverse: Boolean
      )
      @inContext(country: $country) { 
        collection(handle: $handle) {
          products(
            first: ${CONFIG.productsPerPage}, 
            after: $cursor, 
            sortKey: $sortKey, 
            reverse: $reverse, 
            filters: { 
              productMetafield: {
                namespace: "custom"
                key: "gs_product_type"
                value: $productType
              }
            } 
          ) {
            edges {
              cursor
              node {
                id
                title
                handle
                onlineStoreUrl
                featuredImage {
                  url
                  altText
                  width
                  height
                }
                images(first: 10) {
                  nodes {
                    url
                    altText
                    width
                    height
                  }
                }  
                priceRange {
                  maxVariantPrice {
                    amount
                    currencyCode
                  }
                  minVariantPrice {
                    amount
                    currencyCode
                  }
                }
                compareAtPriceRange {
                  maxVariantPrice {
                    amount
                    currencyCode
                  }
                  minVariantPrice {
                    amount
                    currencyCode
                  }
                }
                vendor
                productType
              }
            }
            pageInfo {
              hasNextPage
              hasPreviousPage
              endCursor
            }
          }
        }
      }
    `;

  // ================= SORTING EVENT HANDLER =================
  function initSorting() {
    const sortPopover = document.getElementById('sort-by-popover');
    if (!sortPopover) return;

    // Wait for the popover to be available
    setTimeout(() => {
      const sortButtons = sortPopover.querySelectorAll('.popover__value-option');

      sortButtons.forEach((button) => {
        // Remove existing click events and add our own
        button.replaceWith(button.cloneNode(true));
      });

      // Re-select buttons after cloning
      const newButtons = sortPopover.querySelectorAll('.popover__value-option');

      newButtons.forEach((button) => {
        button.addEventListener('click', async function (e) {
          // Prevent default behavior
          e.preventDefault();
          //e.stopPropagation();
          e.stopImmediatePropagation();

          const sortValue = this.getAttribute('value');
          if (!sortValue) return;

          // Parse sort value
          const { sortKey, reverse } = parseSortOption(sortValue);

          // Update state
          STATE.sortBy = sortValue;
          STATE.sortKey = sortKey;
          STATE.reverse = reverse;
          STATE.currentPage = 1;
          STATE.cursors = [null];
          STATE.endCursor = null;

          // Update UI to show selected sort
          newButtons.forEach((btn) => {
            btn.removeAttribute('aria-selected');
          });
          this.setAttribute('aria-selected', 'true');

          // Close the popover
          sortPopover.style.display = 'none';
          sortPopover.removeAttribute('open');

          // Get current active tab
          const activeTab = document.querySelector('.occasion-tab-content.active');
          console.log('Sorting applied on tab:', activeTab.id, 'productType:', activeTab.dataset.type);
          if (!activeTab) return;

          const productType = activeTab.getAttribute('data-type');
          STATE.productType = productType;

          // Clear current products and show loading
          const productListContainer = activeTab.querySelector('.product-list');
          if (productListContainer) {
            productListContainer.innerHTML = '<div class="loading-indicator">Loading sorted products...</div>';
          }

          // // IMPORTANT: Prevent URL update by Shopify
          // const currentUrl = window.location.href;
          // const cleanUrl = currentUrl.split('?')[0] + '?view=occasion';
          // window.history.replaceState({}, document.title, cleanUrl);

          // Reload products with new sorting
          await loadPage(null, 1, activeTab);

          // Re-fetch pagination cursors
          await fetchCollectionPaginationCursors({
            collectionHandle: STATE.collectionHandle,
            productType: productType,
            sortKey: sortKey,
            reverse: reverse,
            perPage: CONFIG.productsPerPage,
          });

          return false;
        });
      });

      // Also prevent the sort button from opening the popover with default behavior
      const sortByButton = document.querySelector('[aria-controls="sort-by-popover"]');
      if (sortByButton) {
        sortByButton.addEventListener('click', function (e) {
          // Let the popopen open normally, but we'll handle clicks inside it
        });
      }

    }, 1000); // Wait 1 second for everything to load
  }

  // ================= FILTER INTEGRATION =================
  function setupFilterIntegration() {

    // 1. Prevent facets form from submitting and updating URL
    document.addEventListener(
      'submit',
      function (e) {
        const form = e.target;
        if (form.closest('facets-form')) {
          e.preventDefault();
          e.stopImmediatePropagation();

          // Instead of form submission, apply filters via our API
          applyFiltersFromForm(form);
          return false;
        }
      },
      true
    );

    // 2. Handle filter input changes
    document.addEventListener(
      'change',
      function (e) {
        const input = e.target;
        if (input.closest('facets-form') && (input.type === 'checkbox' || input.type === 'radio')) {
          e.preventDefault();
          e.stopImmediatePropagation();

          // Get the form
          const form = input.closest('form');
          if (form) {
            applyFiltersFromForm(form);
          }
        }
      },
      true
    );

    // 3. Handle clear filters link
    document.addEventListener(
      'click',
      function (e) {
        const link = e.target.closest('#clear-filters-link');
        if (link) {
          e.preventDefault();
          e.stopImmediatePropagation();

          clearAllFilters();
          return false;
        }
      },
      true
    );

    // 4. Override facets-form update-on-change behavior
    const facetsForms = document.querySelectorAll('facets-form');
    facetsForms.forEach((form) => {
      // Remove update-on-change attribute to prevent auto-updates
      form.removeAttribute('update-on-change');

      // // Also prevent any internal updates
      // form.addEventListener('facet-change', function(e) {
      //   e.preventDefault();
      //   e.stopImmediatePropagation();
      //   console.log('Facet change event prevented');
      // }, true);
    });
  }

  function applyFiltersFromForm(form) {

    // Store current filters to compare later
    const previousFilters = { ...STATE.activeFilters };

    // Reset filter state
    STATE.activeFilters = {
      color: null,
      productType: null,
    };
    let foundProductTypeFilter = false;

    // Get all checked inputs
    const checkedInputs = form.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked');

    checkedInputs.forEach((input) => {
      const name = input.name || '';
      const value = input.value || '';

      // Parse filter type
      // if (name.includes('color') || name.includes('Color')) {
      if (name.includes('color') || name.includes('Color') || name.includes('filter.v.option.color')) {
        STATE.activeFilters.color = value;
      } else if (name.includes('product_type') || name.includes('product-type') || name.includes('gs_product_type')) {
        STATE.activeFilters.productType = value;
        foundProductTypeFilter = true;
        productTypeValue = value;

        // // If product type filter is applied, find matching tab
        // const matchingTab = findTabByProductType(value);
        // if (matchingTab && !matchingTab.classList.contains('active')) {
        //   // Switch to matching tab
        //   const tabButtons = document.querySelectorAll('.occasion-collection-button');
        //   const tabIndex = Array.from(document.querySelectorAll('.occasion-tab-content')).indexOf(matchingTab);
        //   if (tabButtons[tabIndex]) {
        //     tabButtons[tabIndex].click();
        //     return; // Tab switch will trigger its own reload
        //   }
        // }
      }
    });

    // If product type filter is applied, find matching tab
    if (foundProductTypeFilter && productTypeValue) {
      const matchingTab = findTabByProductType(productTypeValue);
      const matchingTabButton = findTabButtonByProductType(productTypeValue);

      if (matchingTab && !matchingTab.classList.contains('active')) {
        // First scroll the tab button into view
        if (matchingTabButton) {
          scrollTabIntoView(matchingTabButton);
        }

        // Then switch to matching tab
        const tabButtons = document.querySelectorAll('.occasion-collection-button');
        const tabIndex = Array.from(document.querySelectorAll('.occasion-tab-content')).indexOf(matchingTab);

        if (tabButtons[tabIndex]) {
          // Trigger click with a slight delay to allow scroll to complete
          setTimeout(() => {
            tabButtons[tabIndex].click();
          }, 300);
          return; // Tab switch will trigger its own reload
        }
      } else if (matchingTabButton) {
        // Tab is already active, just scroll it into view
        scrollTabIntoView(matchingTabButton);
      }
    }

    // Only update display if filters actually changed
    if (JSON.stringify(previousFilters) !== JSON.stringify(STATE.activeFilters)) {
      updateFilterCountDisplay();
    }

    // // Update filter count display
    // updateFilterCountDisplay();

    // Apply filters to current tab
    reloadCurrentTabWithFilters();
  }

  function findTabByProductType(productType) {
    const tabs = document.querySelectorAll('.occasion-tab-content');
    for (const tab of tabs) {
      const tabProductType = tab.getAttribute('data-type');
      if (tabProductType && tabProductType.toLowerCase() === productType.toLowerCase()) {
        return tab;
      }
    }
    return null;
  }

  function reloadCurrentTabWithFilters() {
    const activeTab = document.querySelector('.occasion-tab-content.active');
    if (!activeTab) return;

    const productType = activeTab.getAttribute('data-type');
    STATE.productType = productType;

    // Show loading
    const productListContainer = activeTab.querySelector('.product-list');
    if (productListContainer) {
      productListContainer.innerHTML = '<div class="loading-indicator">Applying filters...</div>';
    }

    // Reset pagination
    STATE.currentPage = 1;
    STATE.cursors = [null];
    STATE.endCursor = null;

    // Load with filters
    loadPage(null, 1, activeTab);

    // Update pagination cursors
    fetchCollectionPaginationCursors({
      collectionHandle: STATE.collectionHandle,
      productType: productType,
      sortKey: STATE.sortKey,
      reverse: STATE.reverse,
      perPage: CONFIG.productsPerPage,
    });
  }

  function clearAllFilters() {

    // Reset filter state
    STATE.activeFilters = {
      color: null,
      productType: null,
    };

    // // Uncheck all filter inputs
    // const checkedInputs = document.querySelectorAll('facets-form input[type="checkbox"]:checked, facets-form input[type="radio"]:checked');
    // checkedInputs.forEach(input => {
    //   input.checked = false;
    // });

    document.querySelectorAll('facets-form input[type="checkbox"]:checked, facets-form input[type="radio"]:checked')
    .forEach(input => input.checked = false);

    // // Uncheck all filter inputs in both drawer and sidebar
    // const allFilterForms = document.querySelectorAll('facets-form');
    // allFilterForms.forEach((form) => {
    //   const checkedInputs = form.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked');
    //   checkedInputs.forEach((input) => {
    //     input.checked = false;
    //   });
    // });

    // Update filter count display
    updateFilterCountDisplay();

    // Sync drawer filters
    syncDrawerFilters();

    // Reload current tab without filters
    // reloadCurrentTabWithFilters();

    // Switch to "All" tab if not already active
    const allTabButton = document.querySelector('.occasion-collection-button[data-type-handle="all"]');
    if (allTabButton && !allTabButton.classList.contains('active')) {
      allTabButton.click(); // triggers tab switch and reload
    } else {
      // If already on All tab, just reload with no filters
      reloadCurrentTabWithFilters();
    }

    // // Clean URL if needed
    // const currentUrl = window.location.href;
    // if (currentUrl.includes('filter.') || currentUrl.includes('sort_by=')) {
    //   const cleanUrl = currentUrl.split('?')[0] + '?view=occasion';
    //   window.history.replaceState({}, document.title, cleanUrl);
    // }
  }

  // ================= PREVENT DUPLICATE EVENT LISTENERS =================
  function setupFilterIntegration() {

    // Remove any existing listeners first
    const oldForm = document.querySelector('facets-form');
    if (oldForm) {
      const newForm = oldForm.cloneNode(true);
      oldForm.parentNode.replaceChild(newForm, oldForm);
    }

    // 1. Prevent facets form from submitting and updating URL
    document.addEventListener(
      'submit',
      function (e) {
        const form = e.target;
        if (form.closest('facets-form')) {
          e.preventDefault();
          e.stopImmediatePropagation();

          // Instead of form submission, apply filters via our API
          applyFiltersFromForm(form);
          return false;
        }
      },
      true
    );

    // 2. Handle filter input changes
    document.addEventListener(
      'change',
      function (e) {
        const input = e.target;
        if (input.closest('facets-form') && (input.type === 'checkbox' || input.type === 'radio')) {
          e.preventDefault();
          e.stopImmediatePropagation();

          // Get the form
          const form = input.closest('form');
          if (form) {
            // Add small delay to ensure all changes are captured
            setTimeout(() => {
              applyFiltersFromForm(form);
            }, 50);
          }
        }
      },
      true
    );

    // 3. Handle clear filters link
    const clearLink = document.getElementById('clear-filters-link');
    if (clearLink) {
      // Remove any existing click events
      const newClearLink = clearLink.cloneNode(true);
      clearLink.parentNode.replaceChild(newClearLink, clearLink);

      // Add fresh event listener
      newClearLink.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        clearAllFilters();
        return false;
      });
    }

    // 4. Override facets-form update-on-change behavior
    const facetsForms = document.querySelectorAll('facets-form');
    facetsForms.forEach((form) => {
      // Remove update-on-change attribute to prevent auto-updates
      form.removeAttribute('update-on-change');
    });

  }

  // ================= PREVENT URL UPDATES =================
  // function preventURLUpdates() {
  //   // Override Shopify's default URL update behavior
  //   const originalPushState = history.pushState;
  //   const originalReplaceState = history.replaceState;

  //   history.pushState = function(state, title, url) {
  //       // Check if URL contains sort_by parameter
  //       if (url && typeof url === 'string' && url.includes('sort_by=')) {
  //           console.log('Preventing URL update with sort_by:', url);
  //           // Don't update the URL
  //           return;
  //       }
  //       return originalPushState.apply(this, arguments);
  //   };

  //   history.replaceState = function(state, title, url) {
  //       if (url && typeof url === 'string' && url.includes('sort_by=')) {
  //           console.log('Preventing URL replace with sort_by:', url);
  //           return;
  //       }
  //       return originalReplaceState.apply(this, arguments);
  //   };

  //   // Also clean any existing sort_by from URL on page load
  //   if (window.location.href.includes('sort_by=')) {
  //       const cleanUrl = window.location.href.replace(/[?&]sort_by=[^&]*/, '');
  //       window.history.replaceState({}, document.title, cleanUrl);
  //   }
  // }

  function preventURLUpdates() {
    // Override Shopify's default URL update behavior
    const originalPushState = history.pushState;
    const originalReplaceState = history.replaceState;

    // Store the current clean URL (without filter/sort parameters)
    const currentUrl = window.location.href;
    const baseUrl = currentUrl.split('?')[0] + '?view=occasion';

    // Initial clean-up of any existing filter/sort parameters
    if (currentUrl.includes('sort_by=') || currentUrl.includes('filter.')) {
      window.history.replaceState({}, document.title, baseUrl);
    }

    history.pushState = function (state, title, url) {
      // Check if URL contains filter or sort parameters - changed to check for any filter. prefix
      if (url && typeof url === 'string' && (url.includes('sort_by=') || url.includes('filter.'))) {

        // Push the clean URL instead
        const cleanUrl = typeof url === 'string' ? url.split('?')[0] + '?view=occasion' : baseUrl;
        return originalPushState.call(this, state, title, cleanUrl);
      }
      return originalPushState.apply(this, arguments);
    };

    history.replaceState = function (state, title, url) {
      if (url && typeof url === 'string' && (url.includes('sort_by=') || url.includes('filter.'))) {
        const cleanUrl = typeof url === 'string' ? url.split('?')[0] + '?view=occasion' : baseUrl;
        return originalReplaceState.call(this, state, title, cleanUrl);
      }
      return originalReplaceState.apply(this, arguments);
    };

    // Also prevent hash changes that might contain filter data
    window.addEventListener('hashchange', function (e) {
      const newUrl = e.newURL;
      if (newUrl.includes('sort_by=') || newUrl.includes('filter.')) {
        e.preventDefault();
        window.location.hash = '';
      }
    });

    // Prevent clicks on filter links that might update URL
    document.addEventListener(
      'click',
      function (e) {
        const target = e.target;
        const link = target.closest('a');

        if (link && link.href && (link.href.includes('sort_by=') || link.href.includes('filter.'))) {
          e.preventDefault();
          e.stopImmediatePropagation();
          return false;
        }
      },
      true
    );

    // Monitor for Shopify's AJAX calls that update URL
    const originalFetch = window.fetch;
    window.fetch = function (...args) {
      const url = args[0];
      if (typeof url === 'string' && (url.includes('sort_by=') || url.includes('filter.'))) {
        // Clean the URL before fetching
        const cleanUrl = url.split('?')[0];
        args[0] = cleanUrl;
      }
      return originalFetch.apply(this, args);
    };

    // As a last resort, set up a MutationObserver to watch for URL changes
    setupURLObserver();
  }

  function setupURLObserver() {
    // Observe URL changes by checking periodically (fallback method)
    let lastUrl = window.location.href;

    setInterval(() => {
      const currentUrl = window.location.href;
      if (currentUrl !== lastUrl) {
        // Check if URL contains filter parameters
        if (currentUrl.includes('filter.') || currentUrl.includes('sort_by=')) {
          const cleanUrl = currentUrl.split('?')[0] + '?view=occasion';
          window.history.replaceState({}, document.title, cleanUrl);
        }
        lastUrl = currentUrl;
      }
    }, 100);
  }

  // Additional function to clean any existing parameters
  function cleanExistingURLParameters() {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    let hasChanges = false;

    // Remove all filter and sort parameters
    for (const [key] of params) {
      if (key.startsWith('filter.') || key === 'sort_by') {
        params.delete(key);
        hasChanges = true;
      }
    }

    if (hasChanges) {
      // Keep only the 'view' parameter if it exists
      const viewParam = params.get('view');
      const newParams = new URLSearchParams();
      if (viewParam) {
        newParams.set('view', viewParam);
      } else {
        newParams.set('view', 'occasion');
      }

      const newUrl = `${url.origin}${url.pathname}?${newParams.toString()}`;
      window.history.replaceState({}, document.title, newUrl);
    }
  }

  // ================= PREVENT FILTER FORM SUBMISSION =================
  function preventFilterFormSubmission() {
    // Shopify ki default filter form ko prevent karein
    document.addEventListener(
      'submit',
      function (e) {
        const form = e.target;

        // Check if this is a filter form
        const isFilterForm =
          form.closest('.facets') ||
          form.querySelector('input[name*="filter"]') ||
          form.querySelector('select[name*="filter"]');

        if (isFilterForm) {
          e.preventDefault();
          e.stopImmediatePropagation();

          // Clean the URL if it got updated
          setTimeout(() => {
            const currentUrl = window.location.href;
            if (currentUrl.includes('filter.') || currentUrl.includes('sort_by=')) {
              const cleanUrl = currentUrl.split('?')[0] + '?view=occasion';
              window.history.replaceState({}, document.title, cleanUrl);
            }
          }, 10);

          return false;
        }
      },
      true
    );
  }

  // ================= MAIN FUNCTIONS =================

  // Initialize everything
  function initGrid(productType = null, targetTab = null) {
    if (!targetTab || !productType) {
      targetTab = document.querySelector('.occasion-tab-content.active');
      productType = targetTab.getAttribute('data-type');
    }

    // Get collection handle from data attribute
    STATE.productType = productType;

    if (!STATE.collectionHandle) {
      console.error('Error: Add data-collection-handle attribute to .product-list element');
      return;
    }

    // Load first page
    loadPage(null, 1, targetTab);
  }

  //async function fetchCollectionPaginationCursors({ collectionHandle, productType, perPage = 8 }) {
  async function fetchCollectionPaginationCursors({
    collectionHandle,
    productType,
    sortKey = STATE.sortKey,
    reverse = STATE.reverse,
    perPage = 8,
  }) {
    const cursors = [];
    let hasNextPage = true;
    let afterCursor = null;

    // if (paginationContainer) {
    //   paginationContainer.style.display = 'none';
    // }

    // const COLLECTION_PRODUCTS_QUERY = `
    //   query CollectionProducts(
    //   $handle: String!,
    //   $productType: String!,
    //   $first: Int!,
    //   $after: String,
    //   $sortKey: ProductCollectionSortKeys,
    //   $reverse: Boolean
    //   ) {
    //     collection(handle: $handle) {
    //       products(
    //         first: $first,
    //         after: $after,
    //         sortKey: $sortKey,
    //         reverse: $reverse,
    //         filters: {
    //           productMetafield: {
    //             namespace: "custom"
    //             key: "gs_product_type"
    //             value: $productType
    //           }
    //         }
    //       ) {
    //         pageInfo {
    //           hasNextPage
    //           endCursor
    //         }
    //         edges {
    //           cursor
    //           node {
    //             id
    //           }
    //         }
    //       }
    //     }
    //   }
    // `;

    // Build dynamic pagination query with filters
    function getPaginationQuery() {
      let filters = [];

      if (productType) {
        filters.push(`{
            productMetafield: {
              namespace: "custom"
              key: "gs_product_type"
              value: "${productType}"
            }
          }`);
      }

      if (STATE.activeFilters.color) {
        filters.push(`{
            productMetafield: {
              namespace: "luxury"
              key: "color_detail"
              value: "${STATE.activeFilters.color}"
            }
          }`);
      }

      let filtersString = '';
      if (filters.length > 0) {
        filtersString = `filters: [${filters.join(', ')}]`;
      }

      // $productType: String!,
      return `
          query CollectionProducts(
            $handle: String!,
            $first: Int!, 
            $after: String,
            $sortKey: ProductCollectionSortKeys,
            $reverse: Boolean
          ) {
            collection(handle: $handle) {
              products(
                first: $first, 
                after: $after, 
                sortKey: $sortKey, 
                reverse: $reverse
                ${filtersString}
              ) {
                pageInfo {
                  hasNextPage
                  endCursor
                }
                edges {
                  cursor
                  node {
                    id
                  }
                }
              }
            }
          }
        `;
    }

    try {
      while (hasNextPage) {
        const response = await fetch(API_ENDPOINT, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': CONFIG.accessToken,
          },
          body: JSON.stringify({
            // query: COLLECTION_PRODUCTS_QUERY,
            query: getPaginationQuery(),
            variables: {
              handle: collectionHandle,
              // productType: productType,
              first: perPage,
              after: afterCursor,
              sortKey: sortKey,
              reverse: reverse,
            },
          }),
        });

        const json = await response.json();

        const products = json?.data?.collection?.products;
        if (!products) break;

        // Save pagination cursor for this page
        if (products.pageInfo.endCursor) {
          cursors.push(products.pageInfo.endCursor);
        }

        hasNextPage = products.pageInfo.hasNextPage;
        afterCursor = products.pageInfo.endCursor;
      }

      STATE.cursors = cursors;
      // if (paginationContainer) {
      // paginationContainer.style.display = 'flex';
      // }

      return cursors;
    } catch (error) {
      console.error('Error fetching pagination cursors:', error);
      return [];
    }
  }

  // Fetch products from Shopify API
  async function fetchProducts(cursor) {
    try {
      const response = await fetch(API_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': CONFIG.accessToken,
        },
        body: JSON.stringify({
          // query: COLLECTION_PRODUCTS_QUERY,
          query: getGraphQLQuery(),
          variables: {
            handle: STATE.collectionHandle,
            // productType: STATE.productType,
            cursor: cursor,
            country: countryIsoCode,
            sortKey: STATE.sortKey,
            reverse: STATE.reverse,
          },
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const data = await response.json();

      if (data.errors) {
        console.error('GraphQL errors:', data.errors);
        throw new Error(data.errors[0]?.message);
      }
      console.log('GraphQL Response:', data.data.collection.products.edges);
      return data.data.collection.products;
      // console.log('GraphQL Response:', data.data.collection.products.edges);
    } catch (error) {
      console.error('Fetch error:', error);
      return null;
    }
  }

  // Scroll to top of collection grid
  function scrollToCollectionTop() {
    const section = document.querySelector('.main-occasion-collection-grid-view');

    if (!section) return;

    const offset = 120;
    const top = section.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({
      top: top,
      behavior: 'smooth'
    });
  }

  // Load a specific page
  async function loadPage(cursor, pageNumber, targetTab) {
    console.log('JDK : STATE.sortKey:', STATE.sortKey, 'STATE.reverse:', STATE.reverse);

    if (STATE.isLoading) return;

    STATE.isLoading = true;
    showLoading();

    const productsData = await fetchProducts(cursor);

    if (productsData) {
      // Update state
      STATE.hasNextPage = productsData.pageInfo.hasNextPage;
      STATE.hasPreviousPage = productsData.pageInfo.hasPreviousPage;
      STATE.endCursor = productsData.pageInfo.endCursor;

      // Store cursor for this page
      if (pageNumber > STATE.cursors.length) {
        STATE.cursors.push(STATE.endCursor);
      }

      // Update current page
      STATE.currentPage = pageNumber;

      // Render products
      renderProducts(targetTab, productsData.edges);

      // Render pagination
      renderPagination();
    }

    STATE.isLoading = false;
    hideLoading();

  }

  // Render products to the grid
  function renderProducts(targetTab, edges) {
    let productList = document.querySelector('.occasion-tab-content.active .product-list');

    if (!productList) {
      productList = document.querySelector('.occasion-tab-content.active .product-list');
    }

    if (!edges || edges.length === 0) {
      productList.innerHTML = `
      <div class="no-products product-not-found">
        <div class="empty-state">
          <div class="prose">
            <p>This collection is empty</p>
          </div>
      </div>
      `;
      return;
    }

    let productsHTML = '';

    edges.forEach((edge, index) => {
      const product = edge.node;
      const price = parseFloat(product.priceRange.minVariantPrice.amount).toFixed(2);
      const currencyCode = product.priceRange.minVariantPrice.currencyCode;

      const regularPrice = Number(product.compareAtPriceRange.minVariantPrice.amount);
      const regularPriceFormatted = localizationCurrencyCode + ' ' + regularPrice.toLocaleString(languageIsoCode);
      const salePrice = Number(product.priceRange.minVariantPrice.amount);
      const salePriceFormatted = localizationCurrencyCode + ' ' + salePrice.toLocaleString(languageIsoCode);

      let discountPercentage = 0;

      if (regularPrice > salePrice) {
        discountPercentage = Math.round(((regularPrice - salePrice) * 100) / regularPrice);
      }

      const productGid = product.id;

      // Method 1: Split the string and get the last element
      const productId = parseInt(productGid.split('/').pop(), 10);
      // Output: "123456789" (this is a string)

      let priceHTML = '';

      if (isMember != 'false' && isStealBadge != 'false') {
        priceHTML = `
            <div class="price-list--member-login">
              <div class="btn-timing-wrapper">
                <div><button class="btn-member-price">Member Price</button></div>
                <div class="category-status-container">
                  <div class="status-badge sold-out hidden">Sold Out</div>
                  <div class="status-badge ended hidden">Ended</div>
                  <div class="timer timer-layout-${timerType}"
                    data-remaining="${timerRemainingSeconds}"
                    data-days="${timerDays}"
                    data-hours="${timerHours}"
                    data-minutes="${timerMinutes}"
                    data-seconds="${timerSeconds}"
                    >
                    <div class="timer-part-01">
                      <div class="counter-number">
                      ${timerPart01Value}     
                      </div>
                    </div>`;

        if (timerType == 'minutes') {
          priceHTML += `<div>:</div>`;
        }

        priceHTML += `  
                    <div class="timer-part-02">
                      <div class="counter-number">${timerPart02Value}</div>
                    </div>

                  </div>      
                </div>
              </div>
              <price-list class="new-price-list price-list--show-button">
                <sale-price class="text-subdued line-through  price-non-menber">${regularPriceFormatted}</sale-price>
                <div class="discount_price--section">
                  <span class="product-discount">-${discountPercentage}%</span>
                  ${salePriceFormatted}
                </div>
              </price-list>
            </div>  
          `;
      } else {
        if (isStealBadge != 'false') {
          priceHTML = `
            <div class="login-button-price price-list--member-logout">
              <a
                href="#"
                class="transition-button member-price-login-link"
              >
                <div class="original-text">
                  <div class="original-text-section">
                    <img
                    src="https://cdn.shopify.com/s/files/1/0353/4399/0919/files/locked.svg"
                    width="15"
                    height="15"
                  >
                    <span>Member Price is locked</span>
                  </div>
                </div>
                <div class="hover-text">
                  <img
                    src="https://cdn.shopify.com/s/files/1/0353/4399/0919/files/unlock.svg"
                    width="15"
                    height="15"
                  >
                  <span>Sign Up to Unlock</span>
                </div>
              </a>
              <sale-price class="text-subdued">
                ${regularPriceFormatted}
              </sale-price>
            </div>
          `;
        } else {
          priceHTML = `
          <!-----
          <div class="category-status-container">
            <div class="status-badge sold-out">Sold Out</div>
            <div class="status-badge ended">Ended</div>
            <div class="timer timer-layout">
              <div class="timer-part-01">
                <div class="counter-number">
                  <span> 00 </span>
                </div>
              </div>
              <div>:</div>
              <div class="timer-part-02">
                <div class="counter-number">05</div>
              </div>
            </div>
          </div>
          ----->
          <div class="product-individual-price-wrapping without-login-member-price">
            <price-list class="new-price-list">
              <sale-price class="text-on-sale  price-non-menber ">${salePriceFormatted}</sale-price>
              <compare-at-price class="text-subdued line-through  price-non-menber ">${regularPriceFormatted}</compare-at-price>
          </div>
        `;
        }
      }

      productsHTML += `
        <product-card class="product-card new-product-card"
          reveal-on-scroll="true"
          handle="${product.handle}"
          data-product-id="${productId}"
          >
        <div class="product-list-wrapper">
          
          <div class="product-card__figure">
            <div class="swiper product-slider"
              id="product-${productId}-slider"
              data-images_count="${product.images.nodes.length}"
              >
              <div class="swiper-wrapper">`;

                // ---------- SLIDES WITH LAZY LOADING ----------
                product.images.nodes.forEach((image, imageIndex) => {
                  productsHTML += ` 
                    <div class="swiper-slide">
                      <a href="https://www.glamsteals.com/products/${product.handle}" class="product-card__media new-product-card__media">
                        <div class="lazy-fade-image">
                          <!-- Placeholder image (visible initially) -->
                          <img class="placeholder-img" src="${placeholderImageUrl}" alt="loading placeholder" />
                          <!-- Real image (hidden until loaded) -->
                          <img
                            class="real-img"
                            src="${image.url}"
                            alt="${image.altText || 'product image'}"
                            width="${image.width || ''}"
                            height="${image.height || ''}"
                            loading="${imageIndex === 0 ? 'eager' : 'lazy'}"
                            decoding="async"
                            fetchpriority="${imageIndex === 0 ? 'high' : 'low'}"
                          />
                        </div>
                      </a>`;

                  if (isStealBadge != 'false') {
                    productsHTML += `<span class="steal-badge">STEAL</span>`;
                  }

                  productsHTML += `</div>`;
                });
                // ---------- END OF LAZY SLIDES ----------
        
          productsHTML += `      
              </div>
              <div class="swiper-button-next"></div>
              <div class="swiper-button-prev"></div>
            </div>
            <div class="product-card__info empty:hidden product_card_custom">
            <div class="v-stack gap-2">
              <div class="v-stack relative">
                <div class="favorite_icon">
                  <input type="checkbox" class="heart-checkbox"  id="${productId}">
                  <label for="${productId}" class="heart-label">
                    <svg class="heart-icon" viewBox="0 0 24 24">
                      <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
                    </svg>
                  </label>
                </div>
                <a class="vendor brand-title ">${product.vendor}</a>
                <a href="${product.onlineStoreUrl}" class="product-title"> ${product.title} </a>
                <div class="product-individual-price-wrapping w-full">
                  ${priceHTML}
                </div>
              </div>
            </div>
            </div>
          </div>
        </div>
      </product-card>
      `;
    });

    productList.innerHTML = productsHTML;

    // ---------- IMPORTANT: Initialize lazy images ----------
    if (typeof initLazyFadeImages === 'function') {
      initLazyFadeImages();
    }

    // 🔥 CRITICAL: re-init sliders inside active tab
    // window.initSlidersInContext(document.querySelector('.occasion-tab-content.active'));
    window.initSlidersInContext(targetTab);
  }

  // Render pagination buttons
  function renderPagination() {
    // Add event listeners to pagination buttons
    paginationContainer.querySelectorAll('.page-link:not(.disabled)').forEach((button) => {
      button.addEventListener('click', function () {
        const pageNum = parseInt(this.dataset.page);

        window.goToPage(pageNum);
      });
    });

    // return;
  }

  // Navigate to a specific page
  window.goToPage = async (pageNum) => {
    // async function goToPage(pageNum) {

    if (pageNum < 1 || STATE.isLoading) return;

    // If page exists in our cursors array
    if (pageNum <= STATE.cursors.length) {
      // Page 1 has null cursor, other pages use previous cursor
      const cursor = pageNum === 1 ? null : STATE.cursors[pageNum - 2];

      // await loadPage(cursor, pageNum);
      const activeTab = document.querySelector('.occasion-tab-content.active');
      await loadPage(cursor, pageNum, activeTab);
    }
    // If we need to load a new page
    else if (pageNum === STATE.cursors.length + 1 && STATE.hasNextPage) {
      // await loadPage(STATE.endCursor, pageNum);
      const activeTab = document.querySelector('.occasion-tab-content.active');
      await loadPage(STATE.endCursor, pageNum, activeTab);
    }

    scrollToCollectionTop();

  };

  // ================= HELPER FUNCTIONS =================

  function showLoading() {
    let productList = document.querySelector('.occasion-tab-content.active .product-list');

    if (productList) {
      productList.style.opacity = '0.5';
      productList.style.pointerEvents = 'none';
    }
  }

  function hideLoading() {
    let productList = document.querySelector('.occasion-tab-content.active .product-list');

    if (productList) {
      productList.style.opacity = '1';
      productList.style.pointerEvents = 'auto';
    }
  }

  (function () {
    'use strict';

    /* -------------------------
     * Safari detection
     * ------------------------- */
    if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
      document.documentElement.classList.add('safari-browser');
    }

    /* -------------------------
     * Swiper management
     * ------------------------- */

    const swiperInstances = new Map();

    function syncSlideImage(slide) {
      if (!slide) return;

      slide.querySelectorAll('.lazy-fade-image').forEach((wrapper) => {
        const realImg = wrapper.querySelector('.real-img');
        const placeholder = wrapper.querySelector('.placeholder-img');

        if (!realImg || !placeholder) return;

        realImg.loading = 'eager';
        realImg.decoding = 'async';

        if (realImg.complete && realImg.naturalWidth > 0) {
          placeholder.classList.add('hide-placeholder');
          realImg.classList.add('show-real');
          return;
        }

        realImg.addEventListener(
          'load',
          () => {
            placeholder.classList.add('hide-placeholder');
            realImg.classList.add('show-real');
          },
          { once: true }
        );
      });
    }

    function syncSwiperVisibleSlides(swiper) {
      if (!swiper || !swiper.slides || !swiper.slides.length) return;

      const slideIndexes = [swiper.activeIndex, swiper.activeIndex - 1, swiper.activeIndex + 1];

      slideIndexes.forEach((slideIndex) => {
        if (slideIndex < 0 || slideIndex >= swiper.slides.length) return;
        syncSlideImage(swiper.slides[slideIndex]);
      });

      if (typeof window.forceLoadLazyFadeImages === 'function') {
        slideIndexes.forEach((slideIndex) => {
          if (slideIndex < 0 || slideIndex >= swiper.slides.length) return;
          window.forceLoadLazyFadeImages(swiper.slides[slideIndex]);
        });
      }
    }

    function initProductSlider(slider) {
      if (!slider || !slider.id) return;

      const count = Number(slider.dataset.images_count) || 0;
      if (!count) return;

      // Prevent double initialization
      if (slider.dataset.swiperInitialized === 'true') {
        // Recalculate layout when tab becomes visible
        if (slider.swiper && typeof slider.swiper.update === 'function') {
          slider.swiper.update();
        }
        return;
      }

      // Destroy safely if exists
      if (slider.swiper && typeof slider.swiper.destroy === 'function') {
        slider.swiper.destroy(true, true);
      }

      requestAnimationFrame(() => {
        const swiper = new Swiper(slider, {
          loop: count > 1,
          slidesPerView: 1,
          observer: true,
          observeParents: true,
          watchSlidesProgress: true,
          navigation: {
            nextEl: slider.querySelector('.swiper-button-next'),
            prevEl: slider.querySelector('.swiper-button-prev'),
          },
          on: {
            afterInit(swiper) {
              swiper.slideToLoop(swiper.realIndex, 0, false);
              swiper.update();
              syncSwiperVisibleSlides(swiper);

              if (typeof initLazyFadeImages === 'function') {
                initLazyFadeImages();
              }
            },
            resize(swiper) {
              swiper.slideToLoop(swiper.realIndex, 0, false);
              swiper.update();
              syncSwiperVisibleSlides(swiper);
            },
            slideChangeTransitionEnd() {
              syncSwiperVisibleSlides(this);

              if (typeof initLazyFadeImages === 'function') {
                initLazyFadeImages();
              }
            },
          },
        });

        // Store instance safely
        slider.swiper = swiper;
        slider.dataset.swiperInitialized = 'true';

        // Optional: reset on mouse leave
        slider.addEventListener('mouseleave', () => {
          if (swiper && typeof swiper.slideToLoop === 'function') {
            swiper.slideToLoop(0);
          }
        });

        // observeActiveTab();
      });
    }

    window.initSlidersInContext = function (context) {

      if (!context) {
        context = document.querySelector('.occasion-tab-content.active');
      }

      context.querySelectorAll('.product-slider').forEach(initProductSlider);
    };

    /* -------------------------
     * Occasion tabs logic
     * ------------------------- */
    function initOccasionTabs() {

      const buttons = document.querySelectorAll('.occasion-collection-button');
      const tabs = document.querySelectorAll('.occasion-tab-content');

      if (!buttons.length || !tabs.length) return;

      // let currentTab = document.querySelector('.occasion-tab-content.active'); // should be "All"
      let currentTab = document.getElementById('collection-all');
      let currentIndex = 0;
      
      buttons.forEach((btn, index) => {
        btn.addEventListener('click', () => {
          if (index === currentIndex) return; // same tab clicked

          const targetTab = document.getElementById(btn.dataset.tab);
          if (!targetTab) return;

          // Hide old tab
          if (currentTab) currentTab.classList.remove('active');
          // Show new tab
          targetTab.classList.add('active');

          // Update button active states
          buttons.forEach(b => b.classList.remove('active'));
          btn.classList.add('active');

          // Scroll button into view
          scrollTabIntoView(btn);

          // Set product type in state
          const productType = targetTab.dataset.type;
          STATE.productType = (productType === 'all') ? null : productType;

          // Clear any product type filter from the drawer (tabs take precedence)
          if (STATE.activeFilters.productType) {
            STATE.activeFilters.productType = null;
            // Also uncheck product type inputs in UI
            document.querySelectorAll(
              'facets-form input[name*="product_type"]:checked, facets-form input[name*="gs_product_type"]:checked'
            ).forEach(input => input.checked = false);
            updateFilterCountDisplay();
          }

          // Reset pagination for new tab
          STATE.currentPage = 1;
          STATE.cursors = [null];
          STATE.endCursor = null;

          // Show loading and load products
          const productListContainer = targetTab.querySelector('.product-list');
          if (productListContainer) {
            // productListContainer.innerHTML = '<div class="loading-indicator">Loading products...</div>';
          }

          loadPage(null, 1, targetTab);

          // Fetch pagination cursors for this tab
          fetchCollectionPaginationCursors({
            collectionHandle: collectionHandle,
            productType: STATE.productType, // null for "All"
            sortKey: STATE.sortKey,
            reverse: STATE.reverse,
            perPage: CONFIG.productsPerPage,
          });

          // Update pagination UI
          const productsCount = btn.dataset.productsCount || collectionProductsCount;
          const totalPages = Math.ceil(productsCount / CONFIG.productsPerPage);
          createPagination(totalPages, STATE.currentPage);

          currentTab = targetTab;
          currentIndex = index;
        });
      });

      // Once Initit Grid on Page Laod for Active First Tab
      // initGrid();

      // fetchCollectionPaginationCursors({
      //   collectionHandle: collectionHandle,
      //   productType: STATE.productType,
      //   sortKey: STATE.sortKey,
      //   reverse: STATE.reverse,
      //   perPage: 8,
      // });

      // // Initialize sorting functionality
      // initSorting();
      // Initialize first tab
  
      // Initial load: "All" tab is active, load all products
      const allTab = document.querySelector('.occasion-tab-content.active');
      if (allTab) {
        STATE.productType = null;
        const productListContainer = allTab.querySelector('.product-list');
        if (productListContainer) {
          productListContainer.innerHTML = '<div class="loading-indicator">Loading products...</div>';
        }
        loadPage(null, 1, allTab);

        fetchCollectionPaginationCursors({
          collectionHandle: collectionHandle,
          productType: null,
          sortKey: STATE.sortKey,
          reverse: STATE.reverse,
          perPage: CONFIG.productsPerPage,
        });

        const productsCount = collectionProductsCount;
        const totalPages = Math.ceil(productsCount / CONFIG.productsPerPage);
        createPagination(totalPages, 1);
      }
      
      // Initialize sliders in the active tab
      window.initSlidersInContext(currentTab);
    }

    /* -------------------------
     * Shopify-safe initialization
     * ------------------------- */
    function init() {

      const { sortKey, reverse } = parseSortOption(defaultSortBy);

      console.log(' sortKey : ',  sortKey);
      console.log(' reverse : ',  reverse);

      STATE.sortKey = sortKey;
      STATE.reverse = reverse;

      console.log(' STATE.sortKey : ',  STATE.sortKey);
      console.log(' STATE.reverse : ',  STATE.reverse);
      

      // Initialize URL prevention first
      // preventURLUpdates();
      cleanExistingURLParameters();
      // preventFilterFormSubmission();

      initOccasionTabs();

      // Initialize filter integration after tabs are set up
      setTimeout(() => {
        setupFilterIntegration();
        setupDrawerEvents(); // Add this line
      }, 2000);

      // Initialize sorting after a short delay to ensure DOM is ready
      setTimeout(() => {
        initSorting();
      }, 1500);

      // Observe active tab for height adjustments
      setTimeout(() => {
        // observeActiveTab();
      }, 100);

      // Initial filter count display
      setTimeout(() => {
        updateFilterCountDisplay();
      }, 500);
    }

    document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('shopify:section:load', init);

    //////////////////////////

    function createPagination (total, page) {

      // remove pagination if total pages is less then 2
      if( parseInt(total) < 2){
        paginationContainer.style.display = 'none';
      }else{
        paginationContainer.style.display = 'flex';
      }

      const pagination = document.getElementById('pagination');
      pagination.innerHTML = '';

      // Previous button
      const prevLi = document.createElement('li');
      prevLi.className = 'page-item' + (page === 1 ? ' disabled' : '');
      const prevLink = document.createElement('a');
      prevLink.className = 'page-link';
      prevLink.href = page === 1 ? '#' : `?page=${page - 1}`;
      prevLink.textContent = 'Previous';
      prevLink.addEventListener('click', (e) => {
        if (page === 1) e.preventDefault();
        else {
          e.preventDefault();
          STATE.currentPage--;
          window.goToPage(STATE.currentPage);
          createPagination(total, STATE.currentPage);
        }
      });
      prevLi.appendChild(prevLink);
      pagination.appendChild(prevLi);

      // First page
      const firstLi = document.createElement('li');
      firstLi.className = 'page-item' + (page === 1 ? ' active' : '');
      const firstLink = document.createElement('button');
      firstLink.className = 'page-link';
      firstLink.dataset.page = '1';
      firstLink.textContent = '1';
      firstLink.addEventListener('click', (e) => {
        e.preventDefault();
        STATE.currentPage = 1;
        window.goToPage(1);
        createPagination(total, STATE.currentPage);
      });
      firstLi.appendChild(firstLink);
      pagination.appendChild(firstLi);

      // Ellipsis after first page if needed
      if (page > 4) {
        const ellipsisLi = document.createElement('li');
        ellipsisLi.className = 'page-item disabled';
        const ellipsisSpan = document.createElement('span');
        ellipsisSpan.className = 'page-link';
        ellipsisSpan.textContent = '...';
        ellipsisLi.appendChild(ellipsisSpan);
        pagination.appendChild(ellipsisLi);
      }

      // Pages near current page
      let start = Math.max(2, page - 1);
      let end = Math.min(total - 1, page + 1);

      if (page <= 4) {
        start = 2;
        end = 5;
      }
      if (page >= total - 3) {
        start = total - 4;
        end = total - 1;
      }

      /* FIX: Prevent negative or invalid page numbers */
      start = Math.max(2, start);
      end = Math.min(total - 1, end);

      for (let i = start; i <= end; i++) {
        const li = document.createElement('li');
        li.className = 'page-item' + (i === page ? ' active' : '');
        const pageLink = document.createElement('button');
        pageLink.className = 'page-link';
        pageLink.dataset.page = `${i}`;
        pageLink.textContent = i;
        if (i !== page) {
          pageLink.addEventListener('click', (e) => {
            e.preventDefault();
            STATE.currentPage = i;
            window.goToPage(i);
            createPagination(total, STATE.currentPage);
          });
        }
        li.appendChild(pageLink);
        pagination.appendChild(li);
      }

      // Ellipsis before last page if needed
      if (page < total - 3) {
        const ellipsisLi2 = document.createElement('li');
        ellipsisLi2.className = 'page-item disabled';
        const ellipsisSpan2 = document.createElement('span');
        ellipsisSpan2.className = 'page-link';
        ellipsisSpan2.textContent = '...';
        ellipsisLi2.appendChild(ellipsisSpan2);
        pagination.appendChild(ellipsisLi2);
      }

      // Last page
      if (total > 1) {
        const lastLi = document.createElement('li');
        lastLi.className = 'page-item' + (page === total ? ' active' : '');
        const lastLink = document.createElement('button');
        lastLink.className = 'page-link';
        lastLink.dataset.page = `${total}`;
        lastLink.textContent = total;
        if (page !== total) {
          lastLink.addEventListener('click', (e) => {
            e.preventDefault();
            STATE.currentPage = total;
            window.goToPage(total);
            createPagination(total, STATE.currentPage);
          });
        }
        lastLi.appendChild(lastLink);
        pagination.appendChild(lastLi);
      }

      // Next button
      const nextLi = document.createElement('li');
      nextLi.className = 'page-item' + (page === total ? ' disabled' : '');
      const nextLink = document.createElement('button');
      nextLink.className = 'page-link';
      nextLink.dataset.page = page === total ? `${total}` : `${page + 1}`;
      nextLink.textContent = 'Next';
      nextLink.addEventListener('click', (e) => {
        if (page === total) e.preventDefault();
        else {
          e.preventDefault();
          STATE.currentPage++;
          window.goToPage(STATE.currentPage);
          createPagination(total, STATE.currentPage);
        }
      });
      nextLi.appendChild(nextLink);
      pagination.appendChild(nextLi);
    }

    

    //     const parent = document.querySelector('.occasion-collection-tabing');
    // let resizeObserver = null;

    // function observeActiveTab() {
    //   const activeTab = document.querySelector('.occasion-tab-content.active');
    //   if (!activeTab || !parent) return;

    //   // Disconnect old observer
    //   if (resizeObserver) {
    //     resizeObserver.disconnect();
    //   }

    //   resizeObserver = new ResizeObserver(entries => {
    //     for (let entry of entries) {
    //       parent.style.height = entry.contentRect.height + 'px';
    //     }
    //   });

    //   resizeObserver.observe(activeTab);
    // }
  })();

  document.addEventListener('DOMContentLoaded', () => {
    // observeActiveTab();
  });

  } catch(e) { console.error(e); }
})();
})();
